/**
 * @file draft-po-credit.tsx
 * @module app/modules/uProcure/po-management/draft-po-credit
 * @description Credit limit of a draft PO's supplier group (else the supplier): open POs + this
 *   draft against the limit. A warning only: drafts are always created, saved and submitted.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.4.0
 * @version 1.4.0
 */

export interface DraftCredit {
  limit: number | null;
  from: "group" | "supplier" | null;
  used: number;
  openPos: number;
  draft: number;
  availableAfter: number | null;
  over: boolean;
}

const tsh = (n: number) => `TSh ${Math.round(n).toLocaleString("en-US")}`;

const DraftCreditNote = ({ credit }: { credit?: DraftCredit | null }) => {
  if (!credit || credit.limit == null) return null;
  const whose = credit.from === "group" ? "Group credit limit" : "Supplier credit limit";
  return (
    <div className={`alert ${credit.over ? "alert-warning" : "alert-light border"} fs-14 py-3 mb-0 mt-3`} data-testid="draft-credit">
      <span className="fw-bold">{whose}: </span>
      {tsh(credit.limit)} · open POs {tsh(credit.used)} ({credit.openPos}) · this draft {tsh(credit.draft)} ·{" "}
      {credit.over ? (
        <span className="fw-bold text-danger">over by {tsh(Math.abs(credit.availableAfter ?? 0))}. You can still submit.</span>
      ) : (
        <span className="fw-bold text-success">{tsh(credit.availableAfter ?? 0)} left after this PO</span>
      )}
    </div>
  );
};

export default DraftCreditNote;
